<template>
    <div class="legal-container">
        <div class="page-header">
            <h1>用户服务协议</h1>
            <el-button type="primary" @click="goBack">返回</el-button>
        </div>

        <div class="legal-content">
            <div class="update-info">
                <p><strong>更新日期：</strong>2025年1月15日</p>
                <p><strong>生效日期：</strong>2025年1月15日</p>
            </div>

            <div class="content-section">
                <p>欢迎使用启帆数字服务！本协议是您与杭州启帆数字技术有限公司（以下简称"我们"或"启帆数字"）之间关于您使用启帆数字服务所订立的协议。</p>
                <p>在使用启帆数字服务前，您应当认真阅读并遵守本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款。</p>
            </div>

            <div class="content-section">
                <h2>2. 服务内容</h2>
                <p>启帆数字是一个综合性的生活服务信息平台，主要提供以下服务：</p>
                <ul>
                    <li>企业服务信息发布与展示</li>
                    <li>二手商品交易信息展示</li>
                    <li>休闲娱乐活动信息</li>
                    <li>其他相关生活服务信息</li>
                </ul>
            </div>

            <div class="content-section">
                <h2>3. 用户注册与账户</h2>
                <p><strong>3.1 注册资格</strong></p>
                <p>您确认，在您完成注册程序或以其他方式使用本服务时，您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织。</p>

                <p><strong>3.2 账户安全</strong></p>
                <p>您有责任维护账户和密码的安全性，并对在您账户下发生的所有活动承担责任。如发现任何未经授权使用您账户的情况，应立即通知我们。</p>
            </div>

            <div class="content-section">
                <h2>4. 用户行为规范</h2>
                <p>在使用本服务时，您不得进行以下行为：</p>
                <ul>
                    <li>发布虚假、误导性或欺诈性信息</li>
                    <li>发布违法、违规、涉及黄赌毒等不良内容</li>
                    <li>侵犯他人知识产权或其他合法权益</li>
                    <li>恶意攻击、破坏系统安全</li>
                    <li>进行任何可能干扰服务正常运行的活动</li>
                    <li>其他违反法律法规或本协议的行为</li>
                </ul>
            </div>

            <div class="content-section">
                <h2>5. 信息发布规则</h2>
                <p><strong>5.1 内容审核</strong></p>
                <p>您发布的信息需要经过我们的审核。我们有权对不符合要求的内容进行拒绝、删除或修改。</p>

                <p><strong>5.2 信息真实性</strong></p>
                <p>您应确保发布的信息真实、准确、完整，不得发布虚假或误导性信息。</p>
            </div>

            <div class="content-section">
                <h2>6. 知识产权</h2>
                <p>本服务包含的所有内容，包括但不限于文字、图片、音频、视频、软件、程序、版面设计等均受知识产权法律保护。未经我们明确书面许可，您不得复制、传播、展示、修改、转让或使用这些内容。</p>
            </div>

            <div class="content-section">
                <h2>7. 隐私保护</h2>
                <p>我们重视用户隐私保护，具体的隐私政策请参见《隐私政策》。该政策构成本协议的重要组成部分。</p>
            </div>

            <div class="content-section">
                <h2>8. 免责声明</h2>
                <p><strong>8.1 平台性质</strong></p>
                <p>启帆数字仅作为信息展示平台，不参与用户之间的具体交易过程。</p>

                <p><strong>8.2 信息准确性</strong></p>
                <p>我们不保证平台上信息的准确性、完整性或时效性，用户应自行核实相关信息。</p>

                <p><strong>8.3 交易风险</strong></p>
                <p>用户通过平台进行的任何交易活动，风险由用户自行承担。</p>
            </div>

            <div class="content-section">
                <h2>9. 服务变更与终止</h2>
                <p>我们保留随时修改、暂停或终止服务的权利。如有重大变更，我们会提前通知用户。</p>
            </div>

            <div class="content-section">
                <h2>10. 法律适用与争议解决</h2>
                <p>本协议的订立、执行和解释均适用中华人民共和国法律。如发生争议，双方应友好协商解决；协商不成的，可向有管辖权的人民法院提起诉讼。</p>
            </div>

            <div class="content-section">
                <h2>11. 联系我们</h2>
                <p>如您对本协议有任何疑问或建议，请通过以下方式联系我们：</p>
                <ul>
                    <li>邮箱：service282@163.com</li>
                    <li>客服电话：400-852-0210</li>
                    <li>地址：浙江省杭州市余杭区仓前街道景兴路999号8幢404-3室</li>
                </ul>
            </div>

            <div class="footer-note">
                <p>本协议自发布之日起生效。我们保留随时修改本协议的权利，修改后的协议将在网站上公布。</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'UserAgreement',
    methods: {
        goBack() {
            this.$router.go(-1);
        }
    }
}
</script>

<style scoped>
.legal-container {
    max-width: 1000px;
    margin: 0 auto;
    padding: 20px;
    background-color: #f5f5f5;
    min-height: 100vh;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    padding: 20px 30px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.page-header h1 {
    margin: 0;
    color: #333;
    font-size: 24px;
}

.legal-content {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    padding: 40px;
    line-height: 1.8;
}

.update-info {
    background-color: #f8f9fa;
    padding: 15px 20px;
    border-radius: 6px;
    margin-bottom: 30px;
    border-left: 4px solid #409EFF;
}

.update-info p {
    margin: 5px 0;
    color: #666;
    font-size: 14px;
}

.content-section {
    margin-bottom: 30px;
}

.content-section h2 {
    color: #333;
    font-size: 18px;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 2px solid #409EFF;
}

.content-section p {
    color: #555;
    margin-bottom: 12px;
    text-align: justify;
}

.content-section ul {
    margin: 12px 0;
    padding-left: 20px;
}

.content-section li {
    color: #555;
    margin-bottom: 8px;
}

.footer-note {
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid #eee;
    text-align: center;
    color: #999;
    font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .legal-container {
        padding: 10px;
    }

    .page-header {
        flex-direction: column;
        gap: 15px;
        text-align: center;
    }

    .legal-content {
        padding: 20px;
    }

    .page-header h1 {
        font-size: 20px;
    }
}
</style>
